import React from 'react';
import { array, bool, node, object, string } from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { ListingCard, PrimaryEventCard, PaginationLinks } from '../../../components';

import css from './SearchResultsPanel.module.css';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    primaryEvents,
    discoveryItems,
    pagination,
    search,
    setActiveListing,
    isMapVariant,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  const cardRenderSizes = isMapVariant => {
    if (isMapVariant) {
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 767px) 100vw',
        `(max-width: 1023px) ${panelMediumWidth}vw`,
        `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
        `${panelLargeWidth / 3}vw`,
      ].join(', ');
    }
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 549px) 100vw',
      '(max-width: 767px) 50vw',
      `(max-width: 1439px) 26vw`,
      `(max-width: 1920px) 18vw`,
      `14vw`,
    ].join(', ');
  };

  const gridClass = isMapVariant ? css.listingCardsMapVariant : css.listingCards;
  const sizes = cardRenderSizes(isMapVariant);

  const renderMergedItems = () => {
    if (!discoveryItems || !discoveryItems.length) {
      return null;
    }
    return discoveryItems.map(item => {
      if (item.kind === 'primary' && item.event) {
        const ev = item.event;
        return (
          <PrimaryEventCard
            className={css.listingCard}
            key={`primary-${ev.event_id || ev.id}`}
            event={ev}
            renderSizes={sizes}
          />
        );
      }
      if (item.kind === 'listing' && item.listing) {
        const l = item.listing;
        return (
          <ListingCard
            className={css.listingCard}
            key={l.id?.uuid || l.id}
            listing={l}
            renderSizes={sizes}
            setActiveListing={setActiveListing}
          />
        );
      }
      return null;
    });
  };

  const renderLegacySections = () => {
    const primaryRows = primaryEvents || [];
    const listingRows = listings || [];
    return (
      <>
        {primaryRows.map(ev => (
          <PrimaryEventCard
            className={css.listingCard}
            key={`primary-${ev.event_id || ev.id}`}
            event={ev}
            renderSizes={sizes}
          />
        ))}
        {listingRows.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={sizes}
            setActiveListing={setActiveListing}
          />
        ))}
      </>
    );
  };

  const useMerged = discoveryItems != null;

  return (
    <div className={classes}>
      <div className={gridClass}>
        {useMerged ? renderMergedItems() : renderLegacySections()}
        {props.children}
      </div>
      {paginationLinks}
    </div>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  primaryEvents: [],
  discoveryItems: null,
  pagination: null,
  rootClassName: null,
  search: null,
  isMapVariant: true,
};

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  primaryEvents: array,
  discoveryItems: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
  isMapVariant: bool,
};

export default SearchResultsPanel;
